import {url} from "../BaseUrl"; // Import your CSS file
import axios from 'axios';
import React, { useEffect, useState} from "react";

export default function AddDarajat({onClose}) {
    const[value,setValues] = useState({
        nameAr:'',
        nameEn:'',
        url:'',
        Section:''
    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        setValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };

    const closeModalTp = () => {
        onClose(false);
    };
    async function onSubmit ()  {
        const formData = new FormData();
        formData.append('nameAr',value.nameAr);
        formData.append('nameEn',value.nameEn);
        formData.append('url',value.url);
        formData.append('Section',value.Section);

        try{
            const res =  await axios.post(url + '/store_darajat', formData,
                {headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'Access-Control-Allow-Origin': '*'}});
            if(res.status===201 || res.status==="201"){
                // toast.success('تم إضافة النموذج بنجاح');
                // onClose(false);
                closeModalTp()
            }
        }catch (error){
            if(error?.response?.status === 422){
                // toast.error('رقم الإصدار موجود بالفعل');
            }else{
                // toast.error('حدث خطأ. الرجاء المحاولة مرة أخرى.');
            }
        }
        // onClose(false);
    }
    return (
        <div id="modelConfirm" className="fixed z-50 inset-0 bg-gray-900 bg-opacity-60 overflow-y-auto h-full w-full px-4 ">
            <div className="relative top-40 mx-auto shadow-xl rounded-md bg-white max-w-md">
                <div className=" p-2">
                    <button onClick={closeModalTp} type="button"
                            className="top-right text-red-400 bg-transparent hover:bg-gray-200 hover:text-red-700 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center">
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd"
                                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                  clipRule="evenodd"></path>
                        </svg>
                    </button>
                </div>
                <div className="pt-0 text-center">
                    <div className="flex flex-col px-6 py-4 max-w-3xl">
                            <div className="flex flex-row-reverse -mx-3 mb-4">
                                <div className="w-full md:w-2/4 px-3 mb-6 md:mb-0">
                                    <label form="name_model" className="block mb-2 text-gray-700 font-medium  text-right">اسم المادة</label>
                                    <input type="text" id="nameAr"  name="nameAr" value={value.nameAr} onChange={handleChange} className="w-full border border-gray-300 rounded-md py-1 px-4 text-gray-700 focus:border-indigo-500 focus:outline-none text-right" />
                                    {/*{errors.nameAr&&<p className="block text-red-500 text-xs  mt-1 w-full">لا يمكن ترك هذا الحقل فارغًا.</p>}*/}
                                </div>
                                <div className="w-full md:w-2/4 px-3 mb-6 md:mb-0">
                                    <label form="release_date" className="block mb-2 text-gray-700 font-medium  text-right">رمز المادة</label>
                                    <input type="text" id="nameEn"  name="nameEn" value={value.nameEn} onChange={handleChange} className="w-full border border-gray-300 rounded-md py-1 px-4 text-gray-700 focus:border-indigo-500 focus:outline-none text-right" />
                                    {/*{errors.nameEn&&<p className="block text-red-500 text-xs  mt-1 w-full">لا يمكن ترك هذا الحقل فارغًا.</p>}*/}
                                </div>
                            </div>
                            <div className="flex flex-row-reverse -mx-3 mb-4">
                                <div className="w-full md:w-2/4 px-3 mb-6 md:mb-0">
                                    <label form="documentation" className="block mb-2 text-gray-700 font-medium  text-right">القسم</label>
                                    <select  id="Section"  name="Section" value={value.Section} onChange={handleChange} className="w-full border border-gray-300 rounded-md py-1 px-4 text-gray-700 focus:border-indigo-500 focus:outline-none text-right">
                                        <option value="العام">القسم العام</option>
                                        <option value="هندسة برمجيات">القسم هندسة برمجيات</option>
                                        <option value="تقنيات الأنترنت">القسم تقنيات الأنترنت</option>
                                        <option value="الحوسبة المتنقلة">القسم الحوسبة المتنقلة</option>
                                        <option value="الشبكات">القسم الشبكات</option>
                                        <option value="نظم المعلومات">القسم نظم المعلومات</option>
                                    </select>
                                    {/*<input type="text" id="Section"  name="Section" value={value.Section} onChange={handleChange} className="w-full border border-gray-300 rounded-md py-1 px-4 text-gray-700 focus:border-indigo-500 focus:outline-none text-right" />*/}
                                    {/*{errors.Section&&<p className="block text-red-500 text-xs  mt-1 w-full">لا يمكن ترك هذا الحقل فارغًا.</p>}*/}
                                </div>
                                <div className="w-full md:w-2/4 px-3 mb-6 md:mb-0">
                                    <label form="documentation" className="block mb-2 text-gray-700 font-medium  text-right">رابط المنصة</label>
                                    {/*<input type="text" id="url"  name="url" value={value.url} onChange={handleChange} className="w-full border border-gray-300 rounded-md py-1 px-4 text-gray-700 focus:border-indigo-500 focus:outline-none text-right" />*/}
                                    <textarea id="url"  name="url" value={value.url} onChange={handleChange} className="w-full border border-gray-300 rounded-md py-1 px-4 text-gray-700 focus:border-indigo-500 focus:outline-none text-right" />

                                    {/*{errors.url&&<p className="block text-red-500 text-xs  mt-1 w-full">لا يمكن ترك هذا الحقل فارغًا.</p>}*/}
                                </div>
                            </div>
                            <div className="flex flex-row-reverse justify-center items-center mt-4 ">
                                <button  onClick={onSubmit} type="submit" className="mb-2 p-1 text-white font-medium ml-28 border-solid border-2 rounded-md w-20 bg-[#5F82BA]">إضافة</button>
                                <button onClick={closeModalTp} className="mb-2 p-1 font-medium mr-28 border-solid border-2 border-amber-700 rounded-md w-20 ">رجوع</button>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    );
};